module.exports = __webpack_public_path__ + "static/img/shuju@3x.7dc5f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/shuju@3x.jpg
// module id = PBSU
// module chunks = 1